import { render, staticRenderFns } from "./AwsFiles.vue?vue&type=template&id=58ddb698"
import script from "./AwsFiles.vue?vue&type=script&lang=ts"
export * from "./AwsFiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ddb698')) {
      api.createRecord('58ddb698', component.options)
    } else {
      api.reload('58ddb698', component.options)
    }
    module.hot.accept("./AwsFiles.vue?vue&type=template&id=58ddb698", function () {
      api.rerender('58ddb698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aws-files-modules/AwsFiles.vue"
export default component.exports